import PriceMatrixRow from "./PriceMatrixRow";

export default PriceMatrixRow;



// WEBPACK FOOTER //
// ./src/components/PriceMatrixRow/index.js